module.exports = __webpack_public_path__ + "static/media/3-.9bda536a.webp";